import { useContextState } from '../../../../../../hooks/theme'

function useStyles() {
  const { colors } = useContextState()
  return {
    container: {
      display: 'flex',
      flexDirection: 'column',
    },
    card: {
      padding: '18px',
      width: '100%',
      boxShadow: `0px 2px 4px 1px rgba(0,0,0,0.40)`,
    },
    questionText: {
      fontSize: '16px',
      fontWeight: '500',
      color: colors.color22,
      wordBreak: 'break-word',
    },
    answerText: {
      fontSize: '15px',
      color: colors.color22,
      marginTop: '2px',
    },
    noData: {
      fontSize: '14px',
      color: 'c_grey.main',
      textAlign: 'center',
    },
  }
}

export { useStyles }
